<template>
  <div class="modal">
    <b-card no-body class="popup app-ctrl">
      <b-card-header
        style="color: lightgrey; height: 25px;"
        class="pl-2 pb-0 pt-0"
        header-tag="div"
        header-bg-variant="dark"
      >
        <b-row class="mx-0 px-0">
          <b-col class="mx-0 px-0" cols="11">
            {{ 'Excel-Export' }}
          </b-col>
          <b-col class="mx-0 px-0" cols="1" style="text-align: right">
            <font-awesome-icon
              class="mx-1 clickable"
              :icon="['far', 'times']"
              @click="$emit('close')"
            />
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body>
        <slot></slot>
      </b-card-body>
    </b-card>
  </div>
  
</template>

<script>
export default {
  name: "ExportPopup",
}
</script>

<style scoped>
  .popup {
    width: 350px;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .modal {
    display: block;
    background-color: rgba(0, 0, 0, 0.116);
  }
</style>